import {
  renderTime,
} from '../../userUtils';

const getSubject = (details, productName) => {
  const { warningNumber, subject } = details;
  // following this tickets specs
  // https://accuweather.atlassian.net/browse/AESCLIENT-464
  return `${productName} ${warningNumber} - ${subject}`;
};

// TODO: RTH when we want to remove support for using these
const getListHeaderKeyByProductId = (productId, criteriaName) => {
  switch (productId) {
    case 5:
      return 'PRODUCT_DETAILS.PRODUCT_CARDS.HEADERS.EARTHQUAKE_NOTIFICATIONS';
    case 8:
      return 'PRODUCT_DETAILS.PRODUCT_CARDS.HEADERS.STORM_POTENTIAL_NOTICES';
    case 10:
      return 'PRODUCT_DETAILS.PRODUCT_CARDS.HEADERS.STORM_POTENTIAL_OUTLOOKS';
    case 12:
      return 'PRODUCT_DETAILS.PRODUCT_CARDS.HEADERS.GLOBAL_HAZARDS';
    case 14:
      return 'PRODUCT_DETAILS.PRODUCT_CARDS.HEADERS.TROPICAL_NOTIFICATIONS';
    default:
  }
};

// TODO: RTH when we want to remove support for using these
const getMapHeaderKeyByProductId = (productId) => {
  switch (productId) {
    case 5:
      return 'PRODUCT_DETAILS.MAP.HEADERS.EARTHQUAKE_NOTIFICATIONS';
    case 8:
      return 'PRODUCT_DETAILS.MAP.HEADERS.STORM_POTENTIAL_NOTICES';
    case 10:
      return 'PRODUCT_DETAILS.MAP.HEADERS.STORM_POTENTIAL_OUTLOOKS';
    case 12:
      return 'PRODUCT_DETAILS.MAP.HEADERS.GLOBAL_HAZARDS';
    case 14:
      return 'PRODUCT_DETAILS.MAP.HEADERS.TROPICAL_NOTIFICATIONS';
    default:
  }
};

const getCommon = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    id: productEventId,
    content,
  } = event;

  const {
    ackRequired,
    productId,
  } = content;

  const {
    warningNumber,
    issueTime: originalIssueTime,
    severity,
    status,
  } = details;
  const {
    id: severityId,
    name: severityName,
  } = severity;

  const issueTime = renderTime(originalIssueTime, userPreferences);
  const version = 0;

  return {
    productEventId,
    productId,
    status,
    version,
    ackRequired,
    severityName,
    severityId,
    warningNumber,
    issueTime,
  };
};

const getListFeature = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    singularName: productName,
  } = productType;
  const {
    productId,
  } = event.content;

  const {
    validTime,
    expireTime,
    criteria,
    warningNumber,
  } = details;

  const criteriaName = criteria.join(', ');

  // NOTE: this is a temp hack
  let extra = '';
  if (criteriaName === 'No criteria affected') {
    extra = '_NO_CRITERIA';
  }

  const heading = {
    // this will only be set for product notifications for now
    subject: getSubject(details, productName),
    key: getListHeaderKeyByProductId(productId, criteriaName) + extra,
    params: {
      warningNumber,
      criteriaName,
    },
  };

  const startTime = renderTime(validTime, userPreferences, true);
  const endTime = renderTime(expireTime, userPreferences);

  const subtitle = `${startTime} to ${endTime}`;
  return {
    heading,
    subtitle,
  };
};

const getMapFeature = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    singularName: productName,
  } = productType;
  const {
    expireTime,
    validTime,
    warningNumber,
    criteria,
    bbox,
  } = details;
  const {
    productId,
  } = event.content;

  const criteriaName = criteria.join(', ');
  const heading = {
    subject: getSubject(details, productName),
    key: getMapHeaderKeyByProductId(productId),
    params: {
      warningNumber,
    },
  };
  const subtitle = criteriaName;
  const endTime = renderTime(expireTime, userPreferences);
  const startTime = renderTime(validTime, userPreferences);
  const isPointInTime = false;

  return {
    heading,
    subtitle,
    endTime,
    startTime,
    bbox,
    isPointInTime,
  };
};

const getState = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    state,
  } = event;

  const {
    read,
    acked,
  } = state;

  return {
    read,
    acked,
    playingSound,
  };
};

const getFeatures = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => ({
  map: getMapFeature(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
  list: getListFeature(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
});

export default (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  
  const common = getCommon(productType, event, details, playingSound, severities, userPreferences);
  const state = getState(productType, event, details, playingSound, severities, userPreferences);
  const features = getFeatures(productType, event, details, playingSound, severities, userPreferences);
  
  return { common, state, features };
};
